/* eslint-disable */

const defineCustomElement = (name, mount) => window.toozDefineCustomElement(name, [], (el) => {
  let unmount
  return { mounted: () => { unmount = mount(el) }, disconnected: () => unmount?.() }
})


const hideForDays = (days) => document.cookie = `tooz-pop-hide=1; max-age=${86400 * days}; path=/`
const getHidden = () => !!document.cookie.includes('tooz-pop-hide=')
let closeModal = () => {}

const trackGtag = (eventName) => {
  // When popup shows
  if(typeof window.gtag === 'function') gtag('event', eventName, {
    // custom parameter dimension
    source: 'tooz_email_popup_modal_v1'
  })
}

defineCustomElement('tooz-email-pop-loader', (el) => {
  if(getHidden()) return

  const sessionStartAt = Number(window.sessionStorage.getItem('tooz-pop-start') || Date.now())
  window.sessionStorage.setItem('tooz-pop-start', sessionStartAt)
  const sessionMs = Date.now() - sessionStartAt

  setTimeout(() => {
    const modal = el.querySelector('template').content.cloneNode(true).firstElementChild
    console.log('init modal', modal)
    closeModal = () => modal.remove()
    document.body.append(modal)
  }, Math.max(0, (1000 * 10) - sessionMs))
})

let isComplete = false
defineCustomElement('tooz-email-pop-close', (el) => {
  el.addEventListener('click', () => { closeModal(); if(!isComplete) hideForDays(7) })
})

defineCustomElement('tooz-email-pop-form', (el) => {
  const form = el.querySelector('form')
  const input = el.querySelector('input')
  const message = el.querySelector('[data-ref="message"]')

  trackGtag('tooz_email_popup_shown')

  const updateUI = (messageState) => {
    if(messageState === 'loading') {
      form.dataset.loading = ''
    } else if(messageState) {
      message.textContent = messageState
      form.dataset.hide = ''
      delete message.dataset.hide
    } else { // initial
      delete form.dataset.loading
      delete form.dataset.hide
      message.dataset.hide = ''
    }
  }

  const onComplete = () => {
    hideForDays(365);
    isComplete = true;
    input.value = '';
    setTimeout(() => closeModal(), 5000);
    trackGtag('tooz_email_popup_complete');
  }

  const onSubmit = () => {
    const email = input.value.trim()

    // no @ or . found
    if(!/.+@.+\..+/.test(email)) { input.focus(); return }

    updateUI('loading')
    window.fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      body: new URLSearchParams({ g: 'VSPHYp', email }),
      method: 'post'
    })
    .then(res => res.json())
    //.then((payload) => payload.success ? (payload.data.is_subscribed ? 'Nice! You\'re subscribed' : 'Nice! Check your email to confirm') : Promise.reject(payload))
    .then((payload) => payload.success ? 'Nice! You\'re subscribed' : Promise.reject(payload))
    .then((message) => {
      onComplete();
      return message
    })
    .catch((err) => {
      console.error(err);
      setTimeout(() => updateUI(), 5000);
      return 'Sorry, could not add you at this time'
    })
    .then(updateUI)
  }

  form.addEventListener('submit', (e) => { e.preventDefault(); onSubmit() })
})
